// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useSnackbar } from "react-simple-snackbar";
// import { useDispatch } from "react-redux";
// import { useLocation, Link } from "react-router-dom";
// import { deleteProfile, getProfiles } from "../actions/profile";
// import { getUsers, deleteUser } from "../actions/auth";
// import TablePagination from "@material-ui/core/TablePagination";
// import TableFooter from "@material-ui/core/TableFooter";
// import TableContainer from "@material-ui/core/TableContainer";
// import { useMediaQuery } from "@material-ui/core";
// import UserRow from "./userRow";

// import {
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Button,
//   Typography,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   AppBar,
//   Tab,
//   Tabs,
//   Checkbox,
//   TextField,
// } from "@material-ui/core";
// import Container from "@material-ui/core/Container";
// import EditIcon from "@material-ui/icons/Edit";
// import DeleteIcon from "@material-ui/icons/Delete";
// import AddIcon from "@material-ui/icons/Add";
// import { makeStyles, useTheme } from "@material-ui/core/styles";
// import FirstPageIcon from "@material-ui/icons/FirstPage";
// import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
// import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
// import LastPageIcon from "@material-ui/icons/LastPage";
// import PropTypes from "prop-types";
// import Spinner from "../components/Spinner/Spinner";
// import AdminLogin from "./adminLogin/adminLogin";
// import AdminProfiles from "./adminProfiles";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// const useStyles1 = makeStyles((theme) => ({
//   root: {
//     flexShrink: 0,
//     marginLeft: theme.spacing(2.5),
//   },
// }));
// function TablePaginationActions(props) {
//   const classes = useStyles1();
//   const theme = useTheme();
//   const { count, page, rowsPerPage, onPageChange } = props;

//   const handleFirstPageButtonClick = (event) => {
//     onPageChange(event, 0);
//   };

//   const handleBackButtonClick = (event) => {
//     onPageChange(event, page - 1);
//   };

//   const handleNextButtonClick = (event) => {
//     onPageChange(event, page + 1);
//   };

//   const handleLastPageButtonClick = (event) => {
//     onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
//   };

//   return (
//     <div className={classes.root}>
//       <IconButton
//         onClick={handleFirstPageButtonClick}
//         disabled={page === 0}
//         aria-label="first page"
//       >
//         {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
//       </IconButton>
//       <IconButton
//         onClick={handleBackButtonClick}
//         disabled={page === 0}
//         aria-label="previous page"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowRight />
//         ) : (
//           <KeyboardArrowLeft />
//         )}
//       </IconButton>
//       <IconButton
//         onClick={handleNextButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//         aria-label="next page"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowLeft />
//         ) : (
//           <KeyboardArrowRight />
//         )}
//       </IconButton>
//       <IconButton
//         onClick={handleLastPageButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//         aria-label="last page"
//       >
//         {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
//       </IconButton>
//     </div>
//   );
// }
// TablePaginationActions.propTypes = {
//   count: PropTypes.number.isRequired,
//   onPageChange: PropTypes.func.isRequired,
//   page: PropTypes.number.isRequired,
//   rowsPerPage: PropTypes.number.isRequired,
// };
// const useStyles = makeStyles((theme) => ({
//   root: {
//     margin: theme.spacing(2),
//     [theme.breakpoints.up("md")]: {
//       marginLeft: theme.spacing(10),
//     },
//   },
//   title: {
//     marginBottom: theme.spacing(2),
//   },
//   table: {
//     minWidth: 650,
//     marginTop: theme.spacing(6),
//     [theme.breakpoints.down("xs")]: {
//       marginTop: theme.spacing(1)
//       // top: theme.spacing(8),
//       // right: theme.spacing(2),
//       // left: theme.spacing(2),
//     },

//   },
//   buttonGroup: {
//     "& > *": {
//       margin: theme.spacing(1),
//     },
//   },
//   addButton: {
//     // display: 'flex',
//     // alignItems: 'center',
//     // position: 'absolute',
//     // top: theme.spacing(5),
//     // right: theme.spacing(15),

//     [theme.breakpoints.down("xs")]: {
//       display: "flex",
//       flexDirection: "row",
//       // top: theme.spacing(8),
//       // right: theme.spacing(2),
//       // left: theme.spacing(2),
//     },

//     [theme.breakpoints.up("md")]: {
//       display: "flex",
//       alignItems: "Top",
//       position: "absolute",
//       top: theme.spacing(6.5),
//       right: theme.spacing(15),
//       bottom: theme.spacing(2),

//     // Add the bottom margin here
//     },
//   },

//   dialogContent: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     height: "150vh",
//   },
//   link: {
//     textDecoration: "none",
//     color: theme.palette.primary.main,
//     "&:hover": {
//       textDecoration: "underline",
//     },
//   },
//   contentContainer: {
//     width: "100%",
//     marginRight: theme.spacing(2),
//   },
//   responsiveContainer: {
//     [theme.breakpoints.down("xs")]: {
//       marginTop: theme.spacing(2),
//     },
//   },
//   tableContainer: {
//     overflowX: "auto",
//     marginTop: theme.spacing(2),
//   },
//   dialogTitle: {
//     backgroundColor: "#1976D2", // Replace 'primary.main' with your desired blue color
//     color: "#fff", // White text color
//   },
//   addUser: {
//     height : "55px",
//     marginTop: "16px",
//     marginLeft: "16px",
//   },
// }));

// const AdminDashboard = () => {
//   const classes = useStyles();
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   const user = JSON.parse(localStorage.getItem("profile"));
//   const { profiles } = useSelector((state) => state.profiles);
//   const { users } = useSelector((state) => state.auth);
//   console.log("users: ", users);
//   const isLoading = useSelector((state) => state.auth.isLoading);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [openSnackbar, closeSnackbar] = useSnackbar();
//   const [activeTab, setActiveTab] = useState(0);
//   const [searchQuery, setSearchQuery] = useState("");
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const history = useHistory();
//   useEffect(() => {
//     dispatch(getProfiles());
//   }, [location]);

//   useEffect(() => {
//     dispatch(getUsers());
//   }, [location]);

//   const handleOpenDialog = () => {
//     setOpenDialog(true);
//   };
//   const handleUsernameClick = (id) => {
//     history.push(`/userStats/${id}`);
//   };
//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//   };

//   const handleDeleteUser = (id) => {
//     const confirmDelete = window.confirm('Are you sure you want to delete this Sales-Person?');
//     if(confirmDelete){
//     dispatch(deleteUser(id, openSnackbar));
//     const toBeDeleteProfile = profiles.find(
//       (profile) => profile.userId[0] === id
//     );
//     //  console.log("tobeDeletedProfile",toBeDeleteProfile._id);
//     dispatch(deleteProfile(toBeDeleteProfile._id, openSnackbar));
//     }

//   };

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };
//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   if (isLoading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//           paddingTop: "20px",
//         }}
//       >
//         <Spinner />
//       </div>
//     );
//   }
//   const filteredRows = users.filter((row) =>
//     row.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );
//   return (
//     <div>
//       <Container
//         style={{
//           width: isMobile ? "100%":"90%",
//           paddingTop: "2px",
//           paddingBottom: "2px",
//           border: "none",
//           minHeight:isMobile ?740: "510px",
//         }}
//       >
//         <div className={classes.addButton}>
//           <TextField
//             id="search-bar"
//             label="Search"
//             variant="outlined"
//             margin="normal"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//           <Button
//             variant="outlined"
//             style={{color: "#ef7f1a",borderColor:"#ef7f1a" }}
//             startIcon={<AddIcon />}
//             onClick={handleOpenDialog}
//             className={classes.addUser}
//           >
//             Add SalesPerson
//           </Button>
//         </div>
//         <div className={classes.root}>
//           <div className={classes.tableContainer}>
//             <Table className={classes.table}>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>ID</TableCell>
//                   <TableCell>Name</TableCell>
//                   <TableCell>Email</TableCell>
//                   {/* <TableCell>Password</TableCell> */}
//                   <TableCell>Active</TableCell>
//                   <TableCell>Type</TableCell>
//                   <TableCell>Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {(rowsPerPage > 0
//                   ? filteredRows.slice(
//                       page * rowsPerPage,
//                       page * rowsPerPage + rowsPerPage
//                     )
//                   : filteredRows
//                 ).map((user, index) =>

//                   <TableRow key={user._id}>

//                     <TableCell>{index + 1}</TableCell>
//                     <TableCell
//                       onClick={() => {
//                         handleUsernameClick(user._id);
//                       }}
//                       style={{ cursor: "pointer" }}
//                     >
//                       {user.name}
//                     </TableCell>
//                     <TableCell>{user.email}</TableCell>
//                     {/* <TableCell>********</TableCell> */}
//                     <TableCell>
//                       {user?.userType === "admin" ? null : (
//                         <UserRow user={user} />
//                       )}
//                     </TableCell>
//                     <TableCell>
//                       {user?.userType === "admin" ? "Admin" : "User"}
//                     </TableCell>
//                     <TableCell>
//                       {user?.userType === "admin" ? null : (
//                         <div className={classes.buttonGroup}>
//                           <Button
//                             variant="outlined"
//                             style={{color: "#ef7f1a",borderColor: "#ef7f1a"}}
//                             startIcon={<DeleteIcon />}
//                             onClick={() => {
//                               handleDeleteUser(user._id);
//                             }}
//                           >
//                             Delete
//                           </Button>
//                         </div>
//                       )}
//                     </TableCell>

//                   </TableRow>

//                 )}
//               </TableBody>
//               <TableFooter>
//                 <TableRow>
//                   <TablePagination
//                     rowsPerPageOptions={[
//                       5,
//                       10,
//                       25,
//                       { label: "All", value: -1 },
//                     ]}
//                     colSpan={6}
//                     count={filteredRows.length}
//                     rowsPerPage={rowsPerPage}
//                     page={page}
//                     SelectProps={{
//                       inputProps: { "aria-label": "rows per page" },
//                       native: true,
//                     }}
//                     onPageChange={handleChangePage}
//                     onRowsPerPageChange={handleChangeRowsPerPage}
//                     ActionsComponent={TablePaginationActions}
//                   />
//                 </TableRow>
//               </TableFooter>
//             </Table>
//           </div>

//           <Dialog
//             aria-labelledby="customized-dialog-title"
//             open={openDialog}
//             onClose={handleCloseDialog}
//             maxWidth="sm"

//           >
//             <DialogTitle
//               className={classes.dialogTitle}
//               id="customized-dialog-title"
//               style={{backgroundColor: "#ef7f1a"}}
//             >
//               Add Salesperson
//             </DialogTitle>
//             <DialogContent className={classes.dialogContent}>
//               <AdminLogin />
//             </DialogContent>
//             <DialogActions>
//               <Button onClick={handleCloseDialog} color="primary" style={{marginRight:"auto"}}>
//                 Cancel
//               </Button>
//             </DialogActions>
//           </Dialog>
//         </div>
//       </Container>
//     </div>
//   );
// };

// export default AdminDashboard;

//-------------------------------------------------------------------------------------

// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useSnackbar } from "react-simple-snackbar";
// import { useDispatch } from "react-redux";
// import { useLocation, Link } from "react-router-dom";
// import { deleteProfile, getProfiles } from "../actions/profile";
// import { getUsers, deleteUser, updateUser } from "../actions/auth";
// import TablePagination from "@material-ui/core/TablePagination";
// import TableFooter from "@material-ui/core/TableFooter";
// import TableContainer from "@material-ui/core/TableContainer";
// import { useMediaQuery } from "@material-ui/core";
// import UserRow from "./userRow";
// import {
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Button,
//   Typography,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   AppBar,
//   Tab,
//   Tabs,
//   Checkbox,
//   TextField,
// } from "@material-ui/core";
// import Container from "@material-ui/core/Container";
// import EditIcon from "@material-ui/icons/Edit";
// import DeleteIcon from "@material-ui/icons/Delete";
// import AddIcon from "@material-ui/icons/Add";
// import { makeStyles, useTheme } from "@material-ui/core/styles";
// import FirstPageIcon from "@material-ui/icons/FirstPage";
// import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
// import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
// import LastPageIcon from "@material-ui/icons/LastPage";
// import PropTypes from "prop-types";
// import Spinner from "../components/Spinner/Spinner";
// import AdminLogin from "./adminLogin/adminLogin";
// import AdminProfiles from "./adminProfiles";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// const useStyles1 = makeStyles((theme) => ({
//   root: { flexShrink: 0, marginLeft: theme.spacing(2.5) },
// }));

// function TablePaginationActions(props) {
//   const classes = useStyles1();
//   const theme = useTheme();
//   const { count, page, rowsPerPage, onPageChange } = props;
//   const handleFirstPageButtonClick = (event) => {
//     onPageChange(event, 0);
//   };
//   const handleBackButtonClick = (event) => {
//     onPageChange(event, page - 1);
//   };
//   const handleNextButtonClick = (event) => {
//     onPageChange(event, page + 1);
//   };
//   const handleLastPageButtonClick = (event) => {
//     onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
//   };
//   return (
//     <div className={classes.root}>
//       <IconButton
//         onClick={handleFirstPageButtonClick}
//         disabled={page === 0}
//         aria-label="first page"
//       >
//         {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
//       </IconButton>
//       <IconButton
//         onClick={handleBackButtonClick}
//         disabled={page === 0}
//         aria-label="previous page"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowRight />
//         ) : (
//           <KeyboardArrowLeft />
//         )}
//       </IconButton>
//       <IconButton
//         onClick={handleNextButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//         aria-label="next page"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowLeft />
//         ) : (
//           <KeyboardArrowRight />
//         )}
//       </IconButton>
//       <IconButton
//         onClick={handleLastPageButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//         aria-label="last page"
//       >
//         {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
//       </IconButton>
//     </div>
//   );
// }

// TablePaginationActions.propTypes = {
//   count: PropTypes.number.isRequired,
//   onPageChange: PropTypes.func.isRequired,
//   page: PropTypes.number.isRequired,
//   rowsPerPage: PropTypes.number.isRequired,
// };

// const useStyles = makeStyles((theme) => ({
//   root: {
//     margin: theme.spacing(2),
//     [theme.breakpoints.up("md")]: { marginLeft: theme.spacing(10) },
//   },
//   title: { marginBottom: theme.spacing(2) },
//   table: {
//     minWidth: 650,
//     marginTop: theme.spacing(6),
//     [theme.breakpoints.down("xs")]: { marginTop: theme.spacing(1) },
//   },
//   buttonGroup: { "& > *": { margin: theme.spacing(1) } },
//   addButton: {
//     [theme.breakpoints.down("xs")]: { display: "flex", flexDirection: "row" },
//     [theme.breakpoints.up("md")]: {
//       display: "flex",
//       alignItems: "Top",
//       position: "absolute",
//       top: theme.spacing(6.5),
//       right: theme.spacing(15),
//       bottom: theme.spacing(2),
//     },
//   },
//   dialogContent: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     height: "150vh",
//   },
//   link: {
//     textDecoration: "none",
//     color: theme.palette.primary.main,
//     "&:hover": { textDecoration: "underline" },
//   },
//   contentContainer: { width: "100%", marginRight: theme.spacing(2) },
//   responsiveContainer: {
//     [theme.breakpoints.down("xs")]: { marginTop: theme.spacing(2) },
//   },
//   tableContainer: { overflowX: "auto", marginTop: theme.spacing(2) },
//   dialogTitle: { backgroundColor: "#1976D2", color: "#fff" },
//   addUser: { height: "55px", marginTop: "16px", marginLeft: "16px" },
// }));

// const AdminDashboard = () => {
//   const classes = useStyles();
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   const user = JSON.parse(localStorage.getItem("profile"));
//   const { profiles } = useSelector((state) => state.profiles);
//   const { users } = useSelector((state) => state.auth);
//   const isLoading = useSelector((state) => state.auth.isLoading);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [openSnackbar] = useSnackbar();
//   const [activeTab, setActiveTab] = useState(0);
//   const [searchQuery, setSearchQuery] = useState("");
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const history = useHistory();
//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);

//   useEffect(() => {
//     dispatch(getProfiles());
//   }, [location]);
//   useEffect(() => {
//     dispatch(getUsers());
//   }, [location]);

//   const handleOpenDialog = () => {
//     setOpenDialog(true);
//   };
//   const handleUsernameClick = (id) => {
//     history.push(`/userStats/${id}`);
//   };
//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//   };

//   const handleDeleteUser = (id) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this Sales-Person?"
//     );
//     if (confirmDelete) {
//       dispatch(deleteUser(id, openSnackbar));
//       const toBeDeleteProfile = profiles.find(
//         (profile) => profile.userId[0] === id
//       );
//       dispatch(deleteProfile(toBeDeleteProfile._id, openSnackbar));
//     }
//   };

//   const handleEditUser = (user) => {
//     setSelectedUser(user);
//     setEditDialogOpen(true);
//   };
//   const handleUpdateUser = (updatedData) => {
//     dispatch(updateUser(selectedUser._id, updatedData, openSnackbar));
//     setEditDialogOpen(false);
//   };

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };
//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   if (isLoading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//           paddingTop: "20px",
//         }}
//       >
//         <Spinner />
//       </div>
//     );
//   }
//   const filteredRows = users.filter((row) =>
//     row.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   // Step 5: Add debug log for logged-in user
//   console.log("Logged-in User:", user);

//   return (
//     <div>
//       <Container
//         style={{
//           width: isMobile ? "100%" : "90%",
//           paddingTop: "2px",
//           paddingBottom: "2px",
//           border: "none",
//           minHeight: isMobile ? 740 : "510px",
//         }}
//       >
//         <div className={classes.addButton}>
//           <TextField
//             id="search-bar"
//             label="Search"
//             variant="outlined"
//             margin="normal"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//           <Button
//             variant="outlined"
//             style={{ color: "#ef7f1a", borderColor: "#ef7f1a" }}
//             startIcon={<AddIcon />}
//             onClick={handleOpenDialog}
//             className={classes.addUser}
//           >
//             Add SalesPerson
//           </Button>
//         </div>
//         <div className={classes.root}>
//           <div className={classes.tableContainer}>
//             <Table className={classes.table}>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>ID</TableCell>
//                   <TableCell>Name</TableCell>
//                   <TableCell>Email</TableCell>
//                   <TableCell>Active</TableCell>
//                   <TableCell>Type</TableCell>
//                   <TableCell>Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {(rowsPerPage > 0
//                   ? filteredRows.slice(
//                       page * rowsPerPage,
//                       page * rowsPerPage + rowsPerPage
//                     )
//                   : filteredRows
//                 ).map((user, index) => (
//                   <TableRow key={user._id}>
//                     <TableCell>{index + 1}</TableCell>
//                     <TableCell
//                       onClick={() => {
//                         handleUsernameClick(user._id);
//                       }}
//                       style={{ cursor: "pointer" }}
//                     >
//                       {user.name}
//                     </TableCell>
//                     <TableCell>{user.email}</TableCell>
//                     <TableCell>
//                       {user?.userType === "admin" ? null : (
//                         <UserRow user={user} />
//                       )}
//                     </TableCell>
//                     <TableCell>
//                       {user?.userType === "admin" ? "Admin" : "User"}
//                     </TableCell>
//                     <TableCell>
//                       {/* Step 6: Fixed logic for admin override and permissions */}
//                       {/* Why: Ensures admins see all buttons, users see based on permissions */}
//                       <div className={classes.buttonGroup}>
//                         {/* Step 7: Debug log for each row user */}
//                         {console.log("Row User:", user)}
//                         {/* If logged-in user is admin, show buttons for all rows */}
//                         {user.result?.userType === "admin" ? (
//                           <>
//                             <Button
//                               variant="outlined"
//                               style={{
//                                 color: "#ef7f1a",
//                                 borderColor: "#ef7f1a",
//                                 marginRight: "8px",
//                               }}
//                               startIcon={<EditIcon />}
//                               onClick={() => handleEditUser(user)}
//                             >
//                               Edit
//                             </Button>
//                             <Button
//                               variant="outlined"
//                               style={{
//                                 color: "#ef7f1a",
//                                 borderColor: "#ef7f1a",
//                               }}
//                               startIcon={<DeleteIcon />}
//                               onClick={() => handleDeleteUser(user._id)}
//                             >
//                               Delete
//                             </Button>
//                           </>
//                         ) : (
//                           /* For non-admins, check row user's permissions */
//                           user?.userType !== "admin" && (
//                             <>
//                               {user?.permissions?.canEdit && (
//                                 <Button
//                                   variant="outlined"
//                                   style={{
//                                     color: "#ef7f1a",
//                                     borderColor: "#ef7f1a",
//                                     marginRight: "8px",
//                                   }}
//                                   startIcon={<EditIcon />}
//                                   onClick={() => handleEditUser(user)}
//                                 >
//                                   Edit
//                                 </Button>
//                               )}
//                               {user?.permissions?.canDelete && (
//                                 <Button
//                                   variant="outlined"
//                                   style={{
//                                     color: "#ef7f1a",
//                                     borderColor: "#ef7f1a",
//                                   }}
//                                   startIcon={<DeleteIcon />}
//                                   onClick={() => handleDeleteUser(user._id)}
//                                 >
//                                   Delete
//                                 </Button>
//                               )}
//                             </>
//                           )
//                         )}
//                       </div>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//               <TableFooter>
//                 <TableRow>
//                   <TablePagination
//                     rowsPerPageOptions={[
//                       5,
//                       10,
//                       25,
//                       { label: "All", value: -1 },
//                     ]}
//                     colSpan={6}
//                     count={filteredRows.length}
//                     rowsPerPage={rowsPerPage}
//                     page={page}
//                     SelectProps={{
//                       inputProps: { "aria-label": "rows per page" },
//                       native: true,
//                     }}
//                     onPageChange={handleChangePage}
//                     onRowsPerPageChange={handleChangeRowsPerPage}
//                     ActionsComponent={TablePaginationActions}
//                   />
//                 </TableRow>
//               </TableFooter>
//             </Table>
//           </div>
//           <Dialog
//             aria-labelledby="customized-dialog-title"
//             open={openDialog}
//             onClose={handleCloseDialog}
//             maxWidth="sm"
//           >
//             <DialogTitle
//               className={classes.dialogTitle}
//               id="customized-dialog-title"
//               style={{ backgroundColor: "#ef7f1a" }}
//             >
//               Add Salesperson
//             </DialogTitle>
//             <DialogContent className={classes.dialogContent}>
//               <AdminLogin />
//             </DialogContent>
//             <DialogActions>
//               <Button
//                 onClick={handleCloseDialog}
//                 color="primary"
//                 style={{ marginRight: "auto" }}
//               >
//                 Cancel
//               </Button>
//             </DialogActions>
//           </Dialog>
//           <Dialog
//             aria-labelledby="edit-dialog-title"
//             open={editDialogOpen}
//             onClose={() => setEditDialogOpen(false)}
//             maxWidth="sm"
//           >
//             <DialogTitle
//               className={classes.dialogTitle}
//               id="edit-dialog-title"
//               style={{ backgroundColor: "#ef7f1a" }}
//             >
//               Edit User
//             </DialogTitle>
//             <DialogContent className={classes.dialogContent}>
//               <AdminLogin
//                 initialData={selectedUser}
//                 onSubmit={handleUpdateUser}
//               />
//             </DialogContent>
//             <DialogActions>
//               <Button
//                 onClick={() => setEditDialogOpen(false)}
//                 color="primary"
//                 style={{ marginRight: "auto" }}
//               >
//                 Cancel
//               </Button>
//             </DialogActions>
//           </Dialog>
//         </div>
//       </Container>
//     </div>
//   );
// };

// export default AdminDashboard;

//-------------------------------------------------------------

// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useSnackbar } from "react-simple-snackbar";
// import { useDispatch } from "react-redux";
// import { useLocation, Link } from "react-router-dom";
// import { deleteProfile, getProfiles } from "../actions/profile";
// import { getUsers, deleteUser, updateUser } from "../actions/auth";
// import TablePagination from "@material-ui/core/TablePagination";
// import TableFooter from "@material-ui/core/TableFooter";
// import TableContainer from "@material-ui/core/TableContainer";
// import { useMediaQuery } from "@material-ui/core";
// import UserRow from "./userRow";
// import {
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Button,
//   Typography,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   AppBar,
//   Tab,
//   Tabs,
//   Checkbox,
//   TextField,
// } from "@material-ui/core";
// import Container from "@material-ui/core/Container";
// import EditIcon from "@material-ui/icons/Edit";
// import DeleteIcon from "@material-ui/icons/Delete";
// import AddIcon from "@material-ui/icons/Add";
// import { makeStyles, useTheme } from "@material-ui/core/styles";
// import FirstPageIcon from "@material-ui/icons/FirstPage";
// import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
// import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
// import LastPageIcon from "@material-ui/icons/LastPage";
// import PropTypes from "prop-types";
// import Spinner from "../components/Spinner/Spinner";
// import AdminLogin from "./adminLogin/adminLogin";
// import AdminProfiles from "./adminProfiles";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// const useStyles1 = makeStyles((theme) => ({
//   root: { flexShrink: 0, marginLeft: theme.spacing(2.5) },
// }));

// function TablePaginationActions(props) {
//   const classes = useStyles1();
//   const theme = useTheme();
//   const { count, page, rowsPerPage, onPageChange } = props;
//   const handleFirstPageButtonClick = (event) => {
//     onPageChange(event, 0);
//   };
//   const handleBackButtonClick = (event) => {
//     onPageChange(event, page - 1);
//   };
//   const handleNextButtonClick = (event) => {
//     onPageChange(event, page + 1);
//   };
//   const handleLastPageButtonClick = (event) => {
//     onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
//   };
//   return (
//     <div className={classes.root}>
//       <IconButton
//         onClick={handleFirstPageButtonClick}
//         disabled={page === 0}
//         aria-label="first page"
//       >
//         {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
//       </IconButton>
//       <IconButton
//         onClick={handleBackButtonClick}
//         disabled={page === 0}
//         aria-label="previous page"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowRight />
//         ) : (
//           <KeyboardArrowLeft />
//         )}
//       </IconButton>
//       <IconButton
//         onClick={handleNextButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//         aria-label="next page"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowLeft />
//         ) : (
//           <KeyboardArrowRight />
//         )}
//       </IconButton>
//       <IconButton
//         onClick={handleLastPageButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//         aria-label="last page"
//       >
//         {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
//       </IconButton>
//     </div>
//   );
// }

// TablePaginationActions.propTypes = {
//   count: PropTypes.number.isRequired,
//   onPageChange: PropTypes.func.isRequired,
//   page: PropTypes.number.isRequired,
//   rowsPerPage: PropTypes.number.isRequired,
// };

// const useStyles = makeStyles((theme) => ({
//   root: {
//     margin: theme.spacing(2),
//     [theme.breakpoints.up("md")]: { marginLeft: theme.spacing(10) },
//   },
//   title: { marginBottom: theme.spacing(2) },
//   table: {
//     minWidth: 650,
//     marginTop: theme.spacing(6),
//     [theme.breakpoints.down("xs")]: { marginTop: theme.spacing(1) },
//   },
//   buttonGroup: { "& > *": { margin: theme.spacing(1) } },
//   addButton: {
//     [theme.breakpoints.down("xs")]: { display: "flex", flexDirection: "row" },
//     [theme.breakpoints.up("md")]: {
//       display: "flex",
//       alignItems: "Top",
//       position: "absolute",
//       top: theme.spacing(6.5),
//       right: theme.spacing(15),
//       bottom: theme.spacing(2),
//     },
//   },
//   dialogContent: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     height: "150vh",
//   },
//   link: {
//     textDecoration: "none",
//     color: theme.palette.primary.main,
//     "&:hover": { textDecoration: "underline" },
//   },
//   contentContainer: { width: "100%", marginRight: theme.spacing(2) },
//   responsiveContainer: {
//     [theme.breakpoints.down("xs")]: { marginTop: theme.spacing(2) },
//   },
//   tableContainer: { overflowX: "auto", marginTop: theme.spacing(2) },
//   dialogTitle: { backgroundColor: "#1976D2", color: "#fff" },
//   addUser: { height: "55px", marginTop: "16px", marginLeft: "16px" },
// }));

// const AdminDashboard = () => {
//   const classes = useStyles();
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   const user = JSON.parse(localStorage.getItem("profile"));
//   const { profiles } = useSelector((state) => state.profiles);
//   const { users } = useSelector((state) => state.auth);
//   const isLoading = useSelector((state) => state.auth.isLoading);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [openSnackbar] = useSnackbar();
//   const [activeTab, setActiveTab] = useState(0);
//   const [searchQuery, setSearchQuery] = useState("");
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const history = useHistory();
//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [editPermissions, setEditPermissions] = useState({ canEdit: false, canDelete: false });

//   // Step 1: Restrict access to admins only
//   // Why: Ensures only admins can see this page
//   useEffect(() => {
//     if (!user || user.result?.userType !== "admin") {
//       history.push("/login"); // Redirect non-admins to login
//     }
//   }, [user, history]);

//   useEffect(() => {
//     dispatch(getProfiles());
//   }, [location, dispatch]);
//   useEffect(() => {
//     dispatch(getUsers());
//   }, [location, dispatch]);

//   const handleOpenDialog = () => {
//     setOpenDialog(true);
//   };
//   const handleUsernameClick = (id) => {
//     history.push(`/userStats/${id}`);
//   };
//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//   };

//   const handleDeleteUser = (id) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this Sales-Person?"
//     );
//     if (confirmDelete) {
//       dispatch(deleteUser(id, openSnackbar));
//       const toBeDeleteProfile = profiles.find(
//         (profile) => profile.userId[0] === id
//       );
//       dispatch(deleteProfile(toBeDeleteProfile._id, openSnackbar));
//     }
//   };

//   // const handleEditUser = (user) => {
//   //   setSelectedUser(user);
//   //   setEditDialogOpen(true);
//   // };
//   const handleEditUser = (user) => {
//     console.log("Selected User for Edit:", user); // Debug: Verify user data
//     setSelectedUser(user);
//     setEditPermissions(user.permissions || { canEdit: false, canDelete: false }); // Initialize permissions
//     setEditDialogOpen(true);
//   };

//   // const handleUpdateUser = (updatedData) => {
//   //   dispatch(updateUser(selectedUser._id, updatedData, openSnackbar));
//   //   setEditDialogOpen(false);
//   // };
//   const handlePermissionChange = (event) => {
//     setEditPermissions({
//       ...editPermissions,
//       [event.target.name]: event.target.checked,
//     });
//   };

//   const handlePermissionSubmit = () => {
//     handleUpdateUser(editPermissions);
//   };

//   const handleUpdateUser = (permissions) => {
//     const updatePayload = { permissions };
//     console.log("Updating User ID:", selectedUser?._id); // Debug: Check ID
//     console.log("Updated Permissions:", updatePayload); // Debug: Check data
//     dispatch(updateUser(selectedUser?._id, updatePayload, openSnackbar));
//     setEditDialogOpen(false);
//   };
//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };
//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   if (isLoading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//           paddingTop: "20px",
//         }}
//       >
//         <Spinner />
//       </div>
//     );
//   }

//   const filteredRows = users.filter((row) =>
//     row.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <div>
//       {/* Step 2: Ensure only admins can render this content (redundant with useEffect, but kept for clarity) */}
//       {user?.result?.userType === "admin" ? (
//         <Container
//           style={{
//             width: isMobile ? "100%" : "90%",
//             paddingTop: "2px",
//             paddingBottom: "2px",
//             border: "none",
//             minHeight: isMobile ? 740 : "510px",
//           }}
//         >
//           <div className={classes.addButton}>
//             <TextField
//               id="search-bar"
//               label="Search"
//               variant="outlined"
//               margin="normal"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//             {/* Step 3: User creation button (already present) */}
//             <Button
//               variant="outlined"
//               style={{ color: "#ef7f1a", borderColor: "#ef7f1a" }}
//               startIcon={<AddIcon />}
//               onClick={handleOpenDialog}
//               className={classes.addUser}
//             >
//               Add User
//             </Button>
//           </div>
//           <div className={classes.root}>
//             <div className={classes.tableContainer}>
//               <Table className={classes.table}>
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>ID</TableCell>
//                     <TableCell>Name</TableCell>
//                     <TableCell>Email</TableCell>
//                     <TableCell>Active</TableCell>
//                     <TableCell>Type</TableCell>
//                     <TableCell>Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {(rowsPerPage > 0
//                     ? filteredRows.slice(
//                         page * rowsPerPage,
//                         page * rowsPerPage + rowsPerPage
//                       )
//                     : filteredRows
//                   ).map((user, index) => (
//                     <TableRow key={user._id}>
//                       <TableCell>{index + 1}</TableCell>
//                       <TableCell
//                         onClick={() => {
//                           handleUsernameClick(user._id);
//                         }}
//                         style={{ cursor: "pointer" }}
//                       >
//                         {user.name}
//                       </TableCell>
//                       <TableCell>{user.email}</TableCell>
//                       <TableCell>
//                         {user?.userType === "admin" ? null : (
//                           <UserRow user={user} />
//                         )}
//                       </TableCell>
//                       <TableCell>
//                         {user?.userType === "admin" ? "Admin" : "User"}
//                       </TableCell>
//                       <TableCell>
//                         {/* Step 4: Simplified logic - Admins can always edit/delete */}
//                         {/* Why: Admins have full control here; permissions moved to Invoices.js */}
//                         {user.userType !== "admin" && (
//                           <div className={classes.buttonGroup}>
//                             <Button
//                               variant="outlined"
//                               style={{
//                                 color: "#ef7f1a",
//                                 borderColor: "#ef7f1a",
//                                 marginRight: "8px",
//                               }}
//                               startIcon={<EditIcon />}
//                               onClick={() => handleEditUser(user)}
//                             >
//                               Edit
//                             </Button>
//                             <Button
//                               variant="outlined"
//                               style={{
//                                 color: "#ef7f1a",
//                                 borderColor: "#ef7f1a",
//                               }}
//                               startIcon={<DeleteIcon />}
//                               onClick={() => handleDeleteUser(user._id)}
//                             >
//                               Delete
//                             </Button>
//                           </div>
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//                 <TableFooter>
//                   <TableRow>
//                     <TablePagination
//                       rowsPerPageOptions={[
//                         5,
//                         10,
//                         25,
//                         { label: "All", value: -1 },
//                       ]}
//                       colSpan={6}
//                       count={filteredRows.length}
//                       rowsPerPage={rowsPerPage}
//                       page={page}
//                       SelectProps={{
//                         inputProps: { "aria-label": "rows per page" },
//                         native: true,
//                       }}
//                       onPageChange={handleChangePage}
//                       onRowsPerPageChange={handleChangeRowsPerPage}
//                       ActionsComponent={TablePaginationActions}
//                     />
//                   </TableRow>
//                 </TableFooter>
//               </Table>
//             </div>
//             <Dialog
//               aria-labelledby="customized-dialog-title"
//               open={openDialog}
//               onClose={handleCloseDialog}
//               maxWidth="sm"
//             >
//               <DialogTitle
//                 className={classes.dialogTitle}
//                 id="customized-dialog-title"
//                 style={{ backgroundColor: "#ef7f1a" }}
//               >
//                 Add User
//               </DialogTitle>
//               <DialogContent className={classes.dialogContent}>
//                 <AdminLogin />
//               </DialogContent>
//               <DialogActions>
//                 <Button
//                   onClick={handleCloseDialog}
//                   color="primary"
//                   style={{ marginRight: "auto" }}
//                 >
//                   Cancel
//                 </Button>
//               </DialogActions>
//             </Dialog>
//             <Dialog
//               aria-labelledby="edit-dialog-title"
//               open={editDialogOpen}
//               onClose={() => setEditDialogOpen(false)}
//               maxWidth="sm"
//             >
//               <DialogTitle
//                 className={classes.dialogTitle}
//                 id="edit-dialog-title"
//                 style={{ backgroundColor: "#ef7f1a" }}
//               >
//                 Edit User
//               </DialogTitle>
//               {/* <DialogContent className={classes.dialogContent}>

//                 <AdminLogin
//                   initialData={selectedUser}
//                   onSubmit={handleUpdateUser}
//                 />
//               </DialogContent> */}

// <DialogContent className={classes.dialogContent}>
//   <AdminLogin initialData={selectedUser} onSubmit={handleUpdateUser} />
// </DialogContent>
//               <DialogActions>
//                 <Button
//                   onClick={() => setEditDialogOpen(false)}
//                   color="primary"
//                   style={{ marginRight: "auto" }}
//                 >
//                   Cancel
//                 </Button>
//               </DialogActions>
//             </Dialog>
//           </div>
//         </Container>
//       ) : null}
//     </div>
//   );
// };

// export default AdminDashboard;

//=======================

// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useSnackbar } from "react-simple-snackbar";
// import { useDispatch } from "react-redux";
// import { useLocation, Link } from "react-router-dom";
// import { deleteProfile, getProfiles } from "../actions/profile";
// import { getUsers, deleteUser, updateUser } from "../actions/auth";
// import TablePagination from "@material-ui/core/TablePagination";
// import TableFooter from "@material-ui/core/TableFooter";
// import TableContainer from "@material-ui/core/TableContainer";
// import { useMediaQuery } from "@material-ui/core";
// import UserRow from "./userRow";
// import {
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Button,
//   Typography,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   AppBar,
//   Tab,
//   Tabs,
//   Checkbox,
//   TextField,
//   FormControlLabel,
// } from "@material-ui/core";
// import Container from "@material-ui/core/Container";
// import EditIcon from "@material-ui/icons/Edit";
// import DeleteIcon from "@material-ui/icons/Delete";
// import AddIcon from "@material-ui/icons/Add";
// import { makeStyles, useTheme } from "@material-ui/core/styles";
// import FirstPageIcon from "@material-ui/icons/FirstPage";
// import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
// import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
// import LastPageIcon from "@material-ui/icons/LastPage";
// import PropTypes from "prop-types";
// import Spinner from "../components/Spinner/Spinner";
// import AdminLogin from "./adminLogin/adminLogin";
// import AdminProfiles from "./adminProfiles";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// const useStyles1 = makeStyles((theme) => ({
//   root: { flexShrink: 0, marginLeft: theme.spacing(2.5) },
// }));

// function TablePaginationActions(props) {
//   const classes = useStyles1();
//   const theme = useTheme();
//   const { count, page, rowsPerPage, onPageChange } = props;
//   const handleFirstPageButtonClick = (event) => {
//     onPageChange(event, 0);
//   };
//   const handleBackButtonClick = (event) => {
//     onPageChange(event, page - 1);
//   };
//   const handleNextButtonClick = (event) => {
//     onPageChange(event, page + 1);
//   };
//   const handleLastPageButtonClick = (event) => {
//     onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
//   };
//   return (
//     <div className={classes.root}>
//       <IconButton
//         onClick={handleFirstPageButtonClick}
//         disabled={page === 0}
//         aria-label="first page"
//       >
//         {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
//       </IconButton>
//       <IconButton
//         onClick={handleBackButtonClick}
//         disabled={page === 0}
//         aria-label="previous page"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowRight />
//         ) : (
//           <KeyboardArrowLeft />
//         )}
//       </IconButton>
//       <IconButton
//         onClick={handleNextButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//         aria-label="next page"
//       >
//         {theme.direction === "rtl" ? (
//           <KeyboardArrowLeft />
//         ) : (
//           <KeyboardArrowRight />
//         )}
//       </IconButton>
//       <IconButton
//         onClick={handleLastPageButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//         aria-label="last page"
//       >
//         {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
//       </IconButton>
//     </div>
//   );
// }

// TablePaginationActions.propTypes = {
//   count: PropTypes.number.isRequired,
//   onPageChange: PropTypes.func.isRequired,
//   page: PropTypes.number.isRequired,
//   rowsPerPage: PropTypes.number.isRequired,
// };

// // Step 3: Define separate EditPermissionsDialog component
// const EditPermissionsDialog = ({ open, onClose, user, onSave }) => {
//   const [permissions, setPermissions] = useState({ canEdit: false, canDelete: false });

//   useEffect(() => {
//     if (user && user.permissions) {
//       setPermissions({
//         canEdit: user.permissions.canEdit || false,
//         canDelete: user.permissions.canDelete || false,
//       });
//     }
//   }, [user]); // Sync permissions when user changes

//   const handlePermissionChange = (event) => {
//     setPermissions({
//       ...permissions,
//       [event.target.name]: event.target.checked,
//     });
//   };

//   const handlePermissionSubmit = () => {
//     onSave(permissions);
//     onClose();
//   };

//   return (
//     <Dialog
//       aria-labelledby="edit-permissions-dialog-title"
//       open={open}
//       onClose={onClose}
//       maxWidth="sm"
//     >
//       <DialogTitle
//         id="edit-permissions-dialog-title"
//         style={{ backgroundColor: "#ef7f1a", color: "#fff" }}
//       >
//         Edit Permissions
//       </DialogTitle>
//       <DialogContent>
//         <Typography variant="subtitle1">
//           Editing Permissions for {user?.name}
//         </Typography>
//         <FormControlLabel
//           control={
//             <Checkbox
//               checked={permissions.canEdit}
//               onChange={handlePermissionChange}
//               name="canEdit"
//               color="primary"
//             />
//           }
//           label="Can Edit Invoices"
//         />
//         <FormControlLabel
//           control={
//             <Checkbox
//               checked={permissions.canDelete}
//               onChange={handlePermissionChange}
//               name="canDelete"
//               color="primary"
//             />
//           }
//           label="Can Delete Invoices"
//         />
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} color="primary">
//           Cancel
//         </Button>
//         <Button
//           onClick={handlePermissionSubmit}
//           color="primary"
//           variant="contained"
//         >
//           Save
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };
// const useStyles = makeStyles((theme) => ({
//   root: {
//     margin: theme.spacing(2),
//     [theme.breakpoints.up("md")]: { marginLeft: theme.spacing(10) },
//   },
//   title: { marginBottom: theme.spacing(2) },
//   table: {
//     minWidth: 650,
//     marginTop: theme.spacing(6),
//     [theme.breakpoints.down("xs")]: { marginTop: theme.spacing(1) },
//   },
//   buttonGroup: { "& > *": { margin: theme.spacing(1) } },
//   addButton: {
//     [theme.breakpoints.down("xs")]: { display: "flex", flexDirection: "row" },
//     [theme.breakpoints.up("md")]: {
//       display: "flex",
//       alignItems: "Top",
//       position: "absolute",
//       top: theme.spacing(6.5),
//       right: theme.spacing(15),
//       bottom: theme.spacing(2),
//     },
//   },
//   dialogContent: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     height: "150vh",
//   },
//   link: {
//     textDecoration: "none",
//     color: theme.palette.primary.main,
//     "&:hover": { textDecoration: "underline" },
//   },
//   contentContainer: { width: "100%", marginRight: theme.spacing(2) },
//   responsiveContainer: {
//     [theme.breakpoints.down("xs")]: { marginTop: theme.spacing(2) },
//   },
//   tableContainer: { overflowX: "auto", marginTop: theme.spacing(2) },
//   dialogTitle: { backgroundColor: "#1976D2", color: "#fff" },
//   addUser: { height: "55px", marginTop: "16px", marginLeft: "16px" },
// }));

// const AdminDashboard = () => {
//   const classes = useStyles();
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const theme = useTheme();
//   const user = JSON.parse(localStorage.getItem("profile"));
//   const { profiles } = useSelector((state) => state.profiles);
//   const { users } = useSelector((state) => state.auth);
//   const isLoading = useSelector((state) => state.auth.isLoading);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [openSnackbar] = useSnackbar();
//   const [activeTab, setActiveTab] = useState(0);
//   const [searchQuery, setSearchQuery] = useState("");
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const history = useHistory();
//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   // const [editPermissions, setEditPermissions] = useState({ canEdit: false, canDelete: false });

//   useEffect(() => {
//     if (!user || user.result?.userType !== "admin") {
//       history.push("/login");
//     }
//   }, [user, history]);

//   useEffect(() => {
//     dispatch(getProfiles());
//   }, [location, dispatch]);
//   useEffect(() => {
//     dispatch(getUsers());
//   }, [location, dispatch]);

//   const handleOpenDialog = () => {
//     setOpenDialog(true);
//   };
//   const handleUsernameClick = (id) => {
//     history.push(`/userStats/${id}`);
//   };
//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//   };

//   const handleDeleteUser = (id) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this Sales-Person?"
//     );
//     if (confirmDelete) {
//       dispatch(deleteUser(id, openSnackbar));
//       const toBeDeleteProfile = profiles.find(
//         (profile) => profile.userId[0] === id
//       );
//       dispatch(deleteProfile(toBeDeleteProfile._id, openSnackbar));
//     }
//   };

//   // Step 1: Simplify handleEditUser and set initial permissions
//   const handleEditUser = (user) => {
//     console.log("Selected User for Edit:", user);
//     setSelectedUser(user);
//     setEditDialogOpen(true);
//   };

//   // Step 4: Fix handleUpdateUser for permissions only
//   const handleUpdateUser = (permissions) => {
//     const updatePayload = { permissions };
//     console.log("Updating User ID:", selectedUser?._id);
//     console.log("Updated Permissions:", updatePayload);
//     dispatch(updateUser(selectedUser?._id, updatePayload, openSnackbar));
//     setEditDialogOpen(false);
//   };

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };
//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   if (isLoading) {
//     return (
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: "column",
//           paddingTop: "20px",
//         }}
//       >
//         <Spinner />
//       </div>
//     );
//   }

//   const filteredRows = users.filter((row) =>
//     row.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <div>
//       {user?.result?.userType === "admin" ? (
//         <Container
//           style={{
//             width: isMobile ? "100%" : "90%",
//             paddingTop: "2px",
//             paddingBottom: "2px",
//             border: "none",
//             minHeight: isMobile ? 740 : "510px",
//           }}
//         >
//           <div className={classes.addButton}>
//             <TextField
//               id="search-bar"
//               label="Search"
//               variant="outlined"
//               margin="normal"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//             <Button
//               variant="outlined"
//               style={{ color: "#ef7f1a", borderColor: "#ef7f1a" }}
//               startIcon={<AddIcon />}
//               onClick={handleOpenDialog}
//               className={classes.addUser}
//             >
//               Add User
//             </Button>
//           </div>
//           <div className={classes.root}>
//             <div className={classes.tableContainer}>
//               <Table className={classes.table}>
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>ID</TableCell>
//                     <TableCell>Name</TableCell>
//                     <TableCell>Email</TableCell>
//                     <TableCell>Active</TableCell>
//                     <TableCell>Type</TableCell>
//                     <TableCell>Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {(rowsPerPage > 0
//                     ? filteredRows.slice(
//                         page * rowsPerPage,
//                         page * rowsPerPage + rowsPerPage
//                       )
//                     : filteredRows
//                   ).map((user, index) => (
//                     <TableRow key={user._id}>
//                       <TableCell>{index + 1}</TableCell>
//                       <TableCell
//                         onClick={() => {
//                           handleUsernameClick(user._id);
//                         }}
//                         style={{ cursor: "pointer" }}
//                       >
//                         {user.name}
//                       </TableCell>
//                       <TableCell>{user.email}</TableCell>
//                       <TableCell>
//                         {user?.userType === "admin" ? null : (
//                           <UserRow user={user} />
//                         )}
//                       </TableCell>
//                       <TableCell>
//                         {user?.userType === "admin" ? "Admin" : "User"}
//                       </TableCell>
//                       <TableCell>
//                         {user.userType !== "admin" && (
//                           <div className={classes.buttonGroup}>
//                             <Button
//                               variant="outlined"
//                               style={{
//                                 color: "#ef7f1a",
//                                 borderColor: "#ef7f1a",
//                                 marginRight: "8px",
//                               }}
//                               startIcon={<EditIcon />}
//                               onClick={() => handleEditUser(user)}
//                             >
//                               Edit
//                             </Button>
//                             <Button
//                               variant="outlined"
//                               style={{
//                                 color: "#ef7f1a",
//                                 borderColor: "#ef7f1a",
//                               }}
//                               startIcon={<DeleteIcon />}
//                               onClick={() => handleDeleteUser(user._id)}
//                             >
//                               Delete
//                             </Button>
//                           </div>
//                         )}
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//                 <TableFooter>
//                   <TableRow>
//                     <TablePagination
//                       rowsPerPageOptions={[
//                         5,
//                         10,
//                         25,
//                         { label: "All", value: -1 },
//                       ]}
//                       colSpan={6}
//                       count={filteredRows.length}
//                       rowsPerPage={rowsPerPage}
//                       page={page}
//                       SelectProps={{
//                         inputProps: { "aria-label": "rows per page" },
//                         native: true,
//                       }}
//                       onPageChange={handleChangePage}
//                       onRowsPerPageChange={handleChangeRowsPerPage}
//                       ActionsComponent={TablePaginationActions}
//                     />
//                   </TableRow>
//                 </TableFooter>
//               </Table>
//             </div>
//             <Dialog
//               aria-labelledby="customized-dialog-title"
//               open={openDialog}
//               onClose={handleCloseDialog}
//               maxWidth="sm"
//             >
//               <DialogTitle
//                 className={classes.dialogTitle}
//                 id="customized-dialog-title"
//                 style={{ backgroundColor: "#ef7f1a" }}
//               >
//                 Add User
//               </DialogTitle>
//               <DialogContent className={classes.dialogContent}>
//                 <AdminLogin />
//               </DialogContent>
//               <DialogActions>
//                 <Button
//                   onClick={handleCloseDialog}
//                   color="primary"
//                   style={{ marginRight: "auto" }}
//                 >
//                   Cancel
//                 </Button>
//               </DialogActions>
//             </Dialog>
//             {/* Step 4: Use separate EditPermissionsDialog */}
//             <EditPermissionsDialog
//               open={editDialogOpen}
//               onClose={() => setEditDialogOpen(false)}
//               user={selectedUser}
//               onSave={handleUpdateUser}
//             />
//           </div>
//         </Container>
//       ) : null}
//     </div>
//   );
// };

// export default AdminDashboard;

//================================================================================================
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getUsers,
  deleteUser,
  updateUser,
  fetchUserTypes,
  createUserType,
  updateUserType,
  deleteUserType,
} from "../actions/auth";
import TablePagination from "@material-ui/core/TablePagination";
import TableFooter from "@material-ui/core/TableFooter";
import TableContainer from "@material-ui/core/TableContainer";
import { useMediaQuery } from "@material-ui/core";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  AppBar,
  Tab,
  Tabs,
  Checkbox,
  TextField,
  Switch,
  FormControlLabel,
  InputAdornment,
} from "@material-ui/core";
import Container from "@material-ui/core/Container";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import LockIcon from "@material-ui/icons/Lock";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import PropTypes from "prop-types";
import Spinner from "../components/Spinner/Spinner";
import AdminLogin from "./adminLogin/adminLogin";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import UserRow from "./userRow";
import * as api from "../api";

const UserTypePermissionsEditor = ({ open, onClose, userType, onSave }) => {
  const [permissions, setPermissions] = useState({
    pages: userType?.permissions?.pages || [],
    canApplyCustomDiscount:
      userType?.permissions?.canApplyCustomDiscount || false,
    canDownloadPdfReports:
      userType?.permissions?.canDownloadPdfReports || false,
  });
  useEffect(() => {
    if (userType && userType.permissions) {
      setPermissions({
        pages: userType.permissions.pages || [],
        canApplyCustomDiscount:
          userType.permissions.canApplyCustomDiscount || false,
        canDownloadPdfReports:
          userType?.permissions?.canDownloadPdfReports || false,
      });
    }
  }, [userType]);

  const allPages = [
    "Invoice",
    "Items",
    "Units",
    "Purchase",
    "stockAdjustment",
    "Customer",
    "Payment & Recipts",
  ];

  // Ensure all pages are represented in the permissions state
  useEffect(() => {
    const existingPages = permissions.pages.map((p) => p.pageName);
    const missingPages = allPages.filter(
      (page) => !existingPages.includes(page)
    );
    if (missingPages.length > 0) {
      setPermissions((prev) => ({
        ...prev,
        pages: [
          ...prev.pages,
          ...missingPages.map((page) => ({
            pageName: page,
            canCreate: false,
            canRead: true,
            canUpdate: false,
            canDelete: false,
          })),
        ],
      }));
    }
  }, [permissions.pages]);

  const handlePermissionChange = (pageName, permissionType) => (event) => {
    setPermissions((prev) => ({
      ...prev,
      pages: prev.pages.map((page) =>
        page.pageName === pageName
          ? { ...page, [permissionType]: event.target.checked }
          : page
      ),
    }));
  };

  const handleDiscountChange = (event) => {
    setPermissions((prev) => ({
      ...prev,
      canApplyCustomDiscount: event.target.checked,
    }));
  };

  const handlePdfReports = (event) => {
    setPermissions((prev) => ({
      ...prev,
      canDownloadPdfReports: event.target.checked,
    }));
  };

  const handleSave = () => {
    onSave(permissions);
    onClose();
  };

  return (
    <Dialog
      aria-labelledby="edit-usertype-permissions-title"
      open={open}
      onClose={onClose}
      maxWidth="lg"
    >
      <DialogTitle
        id="edit-usertype-permissions-title"
        style={{ backgroundColor: "#ef7f1a", color: "#fff" }}
      >
        Edit Permissions for {userType?.name}
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1">
          Permissions for {userType?.name}
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Page Name</TableCell>
              <TableCell>Create</TableCell>
              <TableCell>View</TableCell>
              <TableCell>Edit</TableCell>
              <TableCell>Delete</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {permissions.pages.map((page) => (
              <TableRow key={page.pageName}>
                <TableCell>{page.pageName}</TableCell>
                <TableCell>
                  <Checkbox
                    checked={page.canCreate}
                    onChange={handlePermissionChange(
                      page.pageName,
                      "canCreate"
                    )}
                    color="primary"
                  />
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={page.canRead}
                    onChange={handlePermissionChange(page.pageName, "canRead")}
                    color="primary"
                  />
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={page.canUpdate}
                    onChange={handlePermissionChange(
                      page.pageName,
                      "canUpdate"
                    )}
                    color="primary"
                  />
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={page.canDelete}
                    onChange={handlePermissionChange(
                      page.pageName,
                      "canDelete"
                    )}
                    color="primary"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Typography variant="subtitle1" style={{ marginTop: "16px" }}>
          Additional Permissions
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={permissions.canApplyCustomDiscount}
              onChange={handleDiscountChange}
              name="canApplyCustomDiscount"
              color="primary"
            />
          }
          label="Can Apply Custom Discount"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={permissions.canDownloadPdfReports}
              onChange={handlePdfReports}
              name="canDownloadPdfReports"
              color="primary"
            />
          }
          label="Can Download Daily Sales Reports"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const UserTypeManagement = ({
  userTypes,
  onCreateUserType,
  onUpdateUserType,
  onDeleteUserType,
  openSnackbar,
}) => {
  const [newUserType, setNewUserType] = useState("");
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState(null);

  const allPages = [
    "Invoice",
    "Items",
    "Units",
    "Purchase",
    "stockAdjustment",
    "Customer",
    "Payment & Recipts",
  ];

  const handleEditUserType = (userType) => {
    setSelectedUserType(userType);
    setEditDialogOpen(true);
  };

  const handleAddUserType = () => {
    if (newUserType) {
      const isAdmin = newUserType.toLowerCase() === "admin";
      console.log(isAdmin);
      const userTypeData = {
        name: newUserType,
        permissions: {
          pages: allPages.map((page) => ({
            pageName: page,
            canCreate: isAdmin,
            canRead: true, // Always true by default
            canUpdate: isAdmin,
            canDelete: isAdmin,
          })),
          canApplyCustomDiscount: isAdmin,
          canDownloadPdfReports: isAdmin,
        },
        active: true,
      };
      console.log("Creating user type:", userTypeData);
      onCreateUserType(userTypeData, openSnackbar);
      setNewUserType("");
    } else {
      openSnackbar("User type name cannot be empty");
    }
  };

  const handleDeleteUserType = (name) => {
    const confirmed = window.confirm(`Are you sure you want to delete the user type "${name}"?`);
    if (confirmed) {
      onDeleteUserType(name, openSnackbar);
    }
  };

  const handleToggleActive = (name) => {
    const userType = userTypes.find((ut) => ut.name === name);
    if (userType) {
      onUpdateUserType(
        name,
        { ...userType, active: !userType.active },
        openSnackbar
      );
    }
  };

  const handleSavePermissions = (permissions) => {
    if (selectedUserType) {
      onUpdateUserType(
        selectedUserType.name,
        { ...selectedUserType, permissions },
        openSnackbar
      );
    }
  };

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        Manage User Types
      </Typography>
      <TextField
        label="New User Type"
        value={newUserType}
        onChange={(e) => setNewUserType(e.target.value)}
        fullWidth
        margin="normal"
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleAddUserType}
        style={{ marginBottom: "16px" }}
      >
        Add User Type
      </Button>
      {Array.isArray(userTypes) && userTypes.length > 0 ? (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>User Type</TableCell>
                <TableCell>Active</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {userTypes.map((ut) => (
                <TableRow key={ut.name}>
                  <TableCell>{ut.name}</TableCell>
                  <TableCell>
                    <Switch
                      checked={ut.active}
                      onChange={() => handleToggleActive(ut.name)}
                      color="primary"
                    />
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleEditUserType(ut)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleDeleteUserType(ut.name)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="body1">No user types available yet.</Typography>
      )}
      <UserTypePermissionsEditor
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        userType={selectedUserType}
        onSave={handleSavePermissions}
      />
    </div>
  );
};

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };
  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };
  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };
  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles1 = makeStyles((theme) => ({
  root: { flexShrink: 0, marginLeft: theme.spacing(2.5) },
}));

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
    [theme.breakpoints.up("md")]: { marginLeft: theme.spacing(10) },
  },
  table: {
    minWidth: 650,
    marginTop: theme.spacing(6),
    [theme.breakpoints.down("xs")]: { marginTop: theme.spacing(1) },
  },
  buttonGroup: { "& > *": { margin: theme.spacing(1) } },
  addButton: {
    [theme.breakpoints.down("xs")]: { display: "flex", flexDirection: "row" },
    [theme.breakpoints.up("md")]: {
      display: "flex",
      alignItems: "Top",
      position: "absolute",
      top: theme.spacing(6.5),
      right: theme.spacing(15),
    },
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "150vh",
    width: "100%",
  },
  tableContainer: { overflowX: "auto", marginTop: theme.spacing(2) },
  addUser: {
    height: "55px",
    marginTop: "16px",
    marginLeft: "16px",
  },
}));

const AdminDashboard = () => {
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { users, userTypes } = useSelector((state) => state.auth);
  const isLoading = useSelector((state) => state.auth.isLoading);
  const [openDialog, setOpenDialog] = useState(false);
  const [openSnackbar] = useSnackbar();
  const [activeTab, setActiveTab] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [changePasswordDialogOpen, setChangePasswordDialogOpen] = useState(false);
  const [selectedUserForPassword, setSelectedUserForPassword] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordChanging, setPasswordChanging] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const history = useHistory();

  useEffect(() => {
    dispatch(getUsers());
    dispatch(fetchUserTypes());
  }, [location, dispatch]);

  const handleOpenDialog = () => {
    setOpenDialog(true);
    dispatch(fetchUserTypes());
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleDeleteUser = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (confirmDelete) {
      dispatch(deleteUser(id, openSnackbar));
    }
  };

  const handleOpenChangePassword = (u) => {
    setSelectedUserForPassword(u);
    setNewPassword("");
    setConfirmPassword("");
    setChangePasswordDialogOpen(true);
  };

  const handleCloseChangePassword = () => {
    setChangePasswordDialogOpen(false);
    setSelectedUserForPassword(null);
    setNewPassword("");
    setConfirmPassword("");
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };

  const handleChangePasswordSubmit = async () => {
    if (!selectedUserForPassword?._id) return;
    if (!newPassword || newPassword.length < 6) {
      openSnackbar("Password must be at least 6 characters");
      return;
    }
    if (newPassword !== confirmPassword) {
      openSnackbar("Passwords do not match");
      return;
    }
    setPasswordChanging(true);
    try {
      await api.adminChangePassword(selectedUserForPassword._id, newPassword);
      openSnackbar("Password updated successfully");
      handleCloseChangePassword();
    } catch (err) {
      openSnackbar(err?.response?.data?.message || "Failed to update password");
    } finally {
      setPasswordChanging(false);
    }
  };

  const handleEditUser = (user) => {
    // For now, we'll just allow editing user details without permissions
    // Implement your own edit dialog if needed
    console.log("Edit user:", user);
  };

  const handleCreateUserType = (userTypeData, openSnackbar) => {
    dispatch(createUserType(userTypeData, openSnackbar));
  };

  const handleUpdateUserType = (name, userTypeData, openSnackbar) => {
    dispatch(updateUserType(name, userTypeData, openSnackbar));
  };

  const handleDeleteUserType = (name, openSnackbar) => {
    dispatch(deleteUserType(name, openSnackbar));
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  const filteredRows = users.filter((row) => {
    if (row.email === "superAdmin@gmail.com") return false;
    return row.name.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <div>
      {Array.isArray(user?.result?.userType) &&
      user?.result?.userType.includes("admin") ? (
        <Container
          style={{
            width: isMobile ? "100%" : "90%",
            paddingTop: "2px",
            paddingBottom: "2px",
            border: "none",
            minHeight: isMobile ? 740 : "510px",
          }}
        >
          <Tabs value={activeTab} onChange={handleTabChange} centered>
            <Tab label="User Management" />
            <Tab label="User Types" />
          </Tabs>

          {activeTab === 0 && (
            <>
              <div className={classes.addButton}>
                <TextField
                  id="search-bar"
                  label="Search"
                  variant="outlined"
                  margin="normal"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Button
                  variant="outlined"
                  style={{ color: "#ef7f1a", borderColor: "#ef7f1a" }}
                  startIcon={<AddIcon />}
                  onClick={handleOpenDialog}
                  className={classes.addUser}
                >
                  Add User
                </Button>
              </div>
              <div className={classes.root}>
                <div className={classes.tableContainer}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Active</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(rowsPerPage > 0
                        ? filteredRows.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                        : filteredRows
                      ).map((user, index) => (
                        <TableRow key={user._id}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{user.name}</TableCell>
                          <TableCell>{user.email}</TableCell>
                          <UserRow
                            user={user}
                            disabled={
                              user?.userType === "admin" ||
                              (Array.isArray(user?.userType) &&
                                user.userType.includes("admin"))
                            }
                          />
                          <TableCell>
                            {Array.isArray(user?.userType)
                              ? user.userType.join(", ")
                              : user?.userType || "User"}
                          </TableCell>
                          <TableCell>
                            <div className={classes.buttonGroup}>
                              <Button
                                variant="outlined"
                                size="small"
                                style={{
                                  color: "#ef7f1a",
                                  borderColor: "#ef7f1a",
                                  marginRight: "8px",
                                }}
                                startIcon={<LockIcon />}
                                onClick={() => handleOpenChangePassword(user)}
                                title="Change password"
                              >
                                Password
                              </Button>
                              {(!Array.isArray(user?.userType) ||
                                !user.userType.includes("admin")) && (
                                <Button
                                  variant="outlined"
                                  size="small"
                                  style={{
                                    color: "#ef7f1a",
                                    borderColor: "#ef7f1a",
                                  }}
                                  startIcon={<DeleteIcon />}
                                  onClick={() => handleDeleteUser(user._id)}
                                >
                                  Delete
                                </Button>
                              )}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[
                            5,
                            10,
                            25,
                            { label: "All", value: -1 },
                          ]}
                          colSpan={6}
                          count={filteredRows.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          SelectProps={{
                            inputProps: { "aria-label": "rows per page" },
                            native: true,
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </div>
              </div>
            </>
          )}

          {activeTab === 1 && (
            <UserTypeManagement
              userTypes={userTypes || []}
              onCreateUserType={handleCreateUserType}
              onUpdateUserType={handleUpdateUserType}
              onDeleteUserType={handleDeleteUserType}
              openSnackbar={openSnackbar}
            />
          )}

          <Dialog
            aria-labelledby="customized-dialog-title"
            open={openDialog}
            onClose={handleCloseDialog}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle
              id="customized-dialog-title"
              style={{ backgroundColor: "#ef7f1a", color: "#fff" }}
            >
              Add User
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
              <AdminLogin userTypes={userTypes || []} />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseDialog}
                color="primary"
                style={{ marginRight: "auto" }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={changePasswordDialogOpen}
            onClose={handleCloseChangePassword}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle
              style={{ backgroundColor: "#ef7f1a", color: "#fff" }}
            >
              Change Password
              {selectedUserForPassword && (
                <span style={{ fontSize: 14, opacity: 0.9, display: "block", marginTop: 4 }}>
                  {selectedUserForPassword.name} ({selectedUserForPassword.email})
                </span>
              )}
            </DialogTitle>
            <DialogContent style={{ padding: 24, paddingTop: 20 }}>
              <TextField
                autoFocus
                margin="dense"
                label="New Password"
                type={showNewPassword ? "text" : "password"}
                fullWidth
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                inputProps={{ minLength: 6 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        edge="end"
                        size="small"
                      >
                        {showNewPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                margin="dense"
                label="Confirm Password"
                type={showConfirmPassword ? "text" : "password"}
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        edge="end"
                        size="small"
                      >
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseChangePassword}>Cancel</Button>
              <Button
                onClick={handleChangePasswordSubmit}
                variant="contained"
                style={{ backgroundColor: "#ef7f1a", color: "#fff" }}
                disabled={passwordChanging}
              >
                {passwordChanging ? "Updating..." : "Update Password"}
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      ) : null}
    </div>
  );
};

export default AdminDashboard;
